import { useState, useCallback } from "react";

interface UseActivityModalStateReturn {
  selectedParticipants: string[];
  setSelectedParticipants: (participants: string[]) => void;
  isFormValid: boolean;
  setIsFormValid: (valid: boolean) => void;
  formSetValue: any;
  setFormSetValue: (setValue: any) => void;
  handleSetValue: (formMethods: { setValue: any; watch: any }) => void;
  resetModalState: () => void;
}

export const useActivityModalState = (): UseActivityModalStateReturn => {
  const [selectedParticipants, setSelectedParticipants] = useState<string[]>(
    []
  );
  const [isFormValid, setIsFormValid] = useState(false);
  const [formSetValue, setFormSetValue] = useState<any>(null);

  const handleSetValue = useCallback(
    (formMethods: { setValue: any; watch: any }) => {
      if (typeof formMethods.setValue === "function") {
        setFormSetValue(() => formMethods.setValue);
      }
    },
    []
  );

  const resetModalState = useCallback(() => {
    setSelectedParticipants([]);
    setIsFormValid(false);
    setFormSetValue(null);
  }, []);

  return {
    selectedParticipants,
    setSelectedParticipants,
    isFormValid,
    setIsFormValid,
    formSetValue,
    setFormSetValue,
    handleSetValue,
    resetModalState
  };
};
